import { graphql, Link } from "gatsby"
import PropTypes from "prop-types"
import RichTextContent from "components/RichTextContent"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function Column3CardGroup({ label, heading, subHeading, boxItems }) {
  return (
    <Container section margin>
      <Heading
        label={label}
        title={heading}
        subtitle={subHeading}
        decoration="line"
      />
      {boxItems && (
        <div className="mt-12 grid grid-cols-1 gap-y-14 md:grid-cols-3 md:gap-x-10 lg:gap-x-12 xl:gap-x-20">
          {boxItems.map(({ id, logo, heading: head, richText, link }) => (
            <Item
              key={id}
              image={logo}
              title={head}
              description={<RichTextContent>{richText}</RichTextContent>}
              link={link}
            />
          ))}
        </div>
      )}
    </Container>
  )
}

function Item({ image, title, description, link }) {
  const content = (
    <>
      {image && (
        <Image
          className="mb-5 max-h-[160px] lg:mx-auto lg:-translate-x-1/2"
          src={image}
        />
      )}
      <h3 className="mt-7 text-2xl font-bold text-black">{title}</h3>
      <div className="mt-2 text-base text-dark-grey">{description}</div>
      {link && (
        <span className="mt-4 inline-block font-semibold text-lush">
          Learn more →
        </span>
      )}
    </>
  )

  if (link) {
    return (
      <Link to={link} className="block transition-opacity hover:opacity-80">
        {content}
      </Link>
    )
  }

  return <div>{content}</div>
}

Column3CardGroup.propTypes = {
  /** Small text that appears above the title */
  label: PropTypes.string,
  /** Heading */
  heading: PropTypes.string,
  /** Sub Heading */
  subHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Items */
  boxItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      heading: PropTypes.string,
      richText: PropTypes.shape({
        raw: PropTypes.string,
      }),
      logo: PropTypes.shape({
        url: PropTypes.string,
        description: PropTypes.string,
      }),
      link: PropTypes.string,
    })
  ),
}

export default Column3CardGroup

export const query = graphql`
  fragment Column3CardGroup on ContentfulColumn3CardGroup {
    id
    __typename
    label
    heading
    subHeading
    boxItems {
      id
      heading
      richText {
        raw
      }
      logo {
        url
        description
      }
    }
  }
`
